export default function Footer() {
  return (
    <footer className="bg-white/10 backdrop-blur-xs border-t border-white/20 py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-xl font-['Pacifico'] text-white mb-4">FourShop</h3>
            <p className="text-white/80 leading-relaxed">
              Uw partner voor <strong>media</strong>, <strong>digitalisering</strong>,
              cadeaus, <strong>relatiegeschenken</strong> en 3D printen.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact</h4>
            <div className="space-y-2 text-white/80">
              <p className="flex items-center gap-2">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
                <a
                  href="tel:0882001110"
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  088 200 1110
                </a>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>
                <a
                  href="mailto:hallo@fourshop.nl"
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  hallo@fourshop.nl
                </a>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center"></i>
                <span>De Corantijn 45, 1689 AN Zwaag</span>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} FourShop.nl. Alle rechten voorbehouden.
          </p>
        </div>
      </div>
    </footer>
  );
}
